import React from 'react'

interface TabContentProps extends React.HTMLProps<HTMLDivElement> {
  children: React.ReactNode
  index: number
  activeTabIndex: number
}

export const TabContent = ({
  children,
  activeTabIndex,
  index
}: TabContentProps) => {
  return (
    <div
      role='tabpanel'
      hidden={activeTabIndex !== index}
      id={`tab-content-${index}`}
      aria-labelledby={`simple-tab-${index}`}>
      {activeTabIndex === index && children}
    </div>
  )
}
